import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { LogedUser } from './core/models/logged-user.model';
import { canAccessDashboard } from './core/dashboard.guard';
import { UserSessionService } from './services/user-session.service';
import { Subscription } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '@base/environments/environment';
import { usesAppLogin } from './core/root-redirect.guard';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  loggedUserSubscription: Subscription | undefined;
  loggedUser: LogedUser | undefined;
  urlNavigated: string | undefined;
  isProd = environment.production;
  private readonly lastCookieValue: string | null = null;


  constructor(
    private readonly router: Router,
    private readonly titleService: Title,
    private readonly userSessionService: UserSessionService,
    private readonly meta: Meta
  ) {}

  ngOnInit(): void {
    this.getLoggedUser();
    if (!this.isProd) this.meta.addTag({ name: 'robots', content: 'noindex' });
  }

  ngAfterViewInit(): void {
    this.detectRoute();
  }

  ngOnDestroy(): void {
    this.loggedUserSubscription?.unsubscribe();
  }

  getLoggedUser(): void {
    const LOGGED_USER_JSON: string | null = localStorage.getItem(
      UserSessionService.LOGGED_USER
    );
    if (LOGGED_USER_JSON) {
      const loggedUser: LogedUser | undefined = JSON.parse(LOGGED_USER_JSON);
      this.loggedUser = loggedUser;
    }
    this.loggedUserSubscription = this.userSessionService.loggedUser$.subscribe(
      (loggedUser: LogedUser | null | undefined) => {
        if (loggedUser != null) {
          this.loggedUser = loggedUser;
          if (this.loggedUser != undefined) {
            this.isAllowedURL();
            this.titleService.setTitle(
              'Gestión - ' + (this.loggedUser.agency_name ?? '')
            );
          }
        }
      }
    );
  }

  detectRoute(): void {
    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.urlNavigated = event.url;
        if (this.loggedUser != undefined) {
          this.isAllowedURL();
        }
      }
    });
  }

  isAllowedURL(): void {
    if (this.loggedUser != undefined && this.urlNavigated != undefined) {
      switch (this.urlNavigated) {
        case '/dashboard':
          if (!canAccessDashboard(this.loggedUser)) {
            this.router.navigate(['/home']);
          }
          break;
        // Sin seguridad
        case '/rrhh':
        case '/stats':
          break;
        case '/movements': 
          if (!this.loggedUser?.security.movements) {
            this.router.navigate(['/']);
          }
          break;
        case '/ctasctes':
          if (!this.loggedUser?.security.cuentas_ctes) {
            this.router.navigate(['/']);
          }
          break;
        case '/rendicion':
          if (!this.loggedUser?.security.renditions) {
            this.router.navigate(['/']);
          }
          break;
        case '/reports':
          if (!this.loggedUser?.security.reports) {
            this.router.navigate(['/']);
          }
          break;
      }
    }
  }

  get shouldShowLoading(): boolean {
    return !usesAppLogin() && !this.loggedUser;
  }
}
